'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedRelative = require('I18n/components/FormattedRelative');

var _FormattedRelative2 = _interopRequireDefault(_FormattedRelative);

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _responderGetters = require('conversations-schema/responders/operators/responderGetters');

var _findAssignedResponder = require('conversations-schema/thread/operators/findAssignedResponder');

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _hasUserAndTeamResponders = require('conversations-schema/chat-heading-config/operators/hasUserAndTeamResponders');

var _ChatHead = require('conversations-internal-components/visitor-widget/ChatHead');

var _ChatHead2 = _interopRequireDefault(_ChatHead);

var _AutomatedMessageAvatars = require('ui-addon-conversations/components/AutomatedMessageAvatars');

var _AutomatedMessageAvatars2 = _interopRequireDefault(_AutomatedMessageAvatars);

var _HR = require('UIComponents/elements/HR');

var _HR2 = _interopRequireDefault(_HR);

var _Small = require('UIComponents/elements/Small');

var _Small2 = _interopRequireDefault(_Small);

var _UIBox = require('UIComponents/layout/UIBox');

var _UIBox2 = _interopRequireDefault(_UIBox);

var _UIStatusTag = require('UIComponents/tag/UIStatusTag');

var _UIStatusTag2 = _interopRequireDefault(_UIStatusTag);

var _CustomChatHeading = require('conversations-internal-components/visitor-widget/CustomChatHeading');

var _CustomChatHeading2 = _interopRequireDefault(_CustomChatHeading);

var _ThreadPreviewText = require('./ThreadPreviewText');

var _ThreadPreviewText2 = _interopRequireDefault(_ThreadPreviewText);

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var indicatorDimension = '10px';

var ThreadListItem = _react2.default.createClass({
  displayName: 'ThreadListItem',

  propTypes: {
    botResponder: (0, _RecordPropType2.default)('Responder'),
    chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
    coloring: (0, _RecordPropType2.default)('ColoringRecord'),
    initialResponder: (0, _RecordPropType2.default)('Responder').isRequired,
    latestMessage: (0, _RecordPropType2.default)('PubNubMessageRecord').isRequired,
    onClick: _react.PropTypes.func.isRequired,
    potentialResponders: _react.PropTypes.instanceOf(_immutable.List),
    responders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
    thread: _react.PropTypes.instanceOf(_immutable.Record).isRequired,
    unseenCount: _react.PropTypes.number.isRequired
  },

  getSingleResponder: function getSingleResponder() {
    var _props = this.props,
        initialResponder = _props.initialResponder,
        thread = _props.thread,
        botResponder = _props.botResponder,
        responders = _props.responders;


    var currentAssignedResponder = (0, _findAssignedResponder.findAssignedResponder)({
      thread: thread,
      responders: responders,
      botResponder: botResponder
    });

    return currentAssignedResponder || initialResponder;
  },
  getNameText: function getNameText() {
    var potentialResponders = this.props.potentialResponders;


    if (this.shouldRenderMultipleAvatars()) {
      return potentialResponders.map(_responderGetters.getFirstName).join(', ');
    }

    return (0, _responderGetters.getFirstName)(this.getSingleResponder());
  },
  shouldRenderMultipleAvatars: function shouldRenderMultipleAvatars() {
    var _props2 = this.props,
        potentialResponders = _props2.potentialResponders,
        chatHeadingConfig = _props2.chatHeadingConfig;

    return !this.getSingleResponder() && (0, _hasUserAndTeamResponders.hasUserAndTeamResponders)(chatHeadingConfig) && potentialResponders && potentialResponders.size > 1;
  },
  renderSingleAvatar: function renderSingleAvatar() {
    var responderToRender = this.getSingleResponder();

    var avatar = (0, _responderGetters.getAvatar)(responderToRender);
    var online = (0, _responderGetters.getIsOnline)(responderToRender);
    var isBot = (0, _responderGetters.getIsBot)(responderToRender);
    if (responderToRender) {
      return _react2.default.createElement(_ChatHead2.default, {
        avatar: avatar,
        isBot: isBot,
        online: online,
        className: 'visitor-chat-head',
        isVisitorWidget: true
      });
    }
    return _react2.default.createElement(_CustomChatHeading2.default, { chatHeadingConfig: this.props.chatHeadingConfig });
  },
  renderAvatar: function renderAvatar() {
    var potentialResponders = this.props.potentialResponders;


    if (this.shouldRenderMultipleAvatars()) {
      return _react2.default.createElement(_AutomatedMessageAvatars2.default, {
        size: 'large',
        responders: potentialResponders
      });
    }

    return this.renderSingleAvatar();
  },
  renderTimestamp: function renderTimestamp() {
    var timestamp = (0, _commonMessageFormatGetters.getTimestamp)(this.props.latestMessage);

    return _react2.default.createElement(_FormattedRelative2.default, { value: timestamp });
  },
  renderText: function renderText() {
    return _react2.default.createElement(_ThreadPreviewText2.default, {
      latestMessage: this.props.latestMessage,
      unseenCount: this.props.unseenCount
    });
  },
  renderUnseenIndicator: function renderUnseenIndicator() {
    return _react2.default.createElement(_UIBox2.default, {
      basis: indicatorDimension,
      shrink: 0,
      className: 'unseen-indicator m-top-6 m-right-2',
      style: this.getUnseenIndicatorStyle()
    });
  },
  render: function render() {
    var _props3 = this.props,
        coloring = _props3.coloring,
        unseenCount = _props3.unseenCount;


    var nameText = this.getNameText();

    return _react2.default.createElement(
      'div',
      {
        className: 'selenium-test-marker-thread-list-item thread-list-item p-x-5 p-top-5',
        style: { cursor: 'pointer' },
        onClick: this.props.onClick
      },
      _react2.default.createElement(
        'div',
        { className: 'display-flex' },
        _react2.default.createElement(
          _UIBox2.default,
          { alignSelf: 'center' },
          _react2.default.createElement(_UIStatusTag2.default, {
            color: unseenCount ? coloring.get('accentColor') : 'transparent'
          })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'display-flex justify-center m-right-3',
            style: { minWidth: 48 }
          },
          this.renderAvatar()
        ),
        _react2.default.createElement(
          'div',
          { style: { flexGrow: 1 } },
          _react2.default.createElement(
            _Small2.default,
            { className: 'justify-between', use: 'help' },
            _react2.default.createElement(
              'span',
              null,
              nameText
            ),
            this.renderTimestamp()
          ),
          this.renderText()
        )
      ),
      _react2.default.createElement(_HR2.default, { className: 'thread-separator', distance: 'small' })
    );
  }
});

exports.default = ThreadListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/threads/components/ThreadListItem.js
// module id = 973
// module chunks = 2 3